import closeBtn from 'Assets/images/close-btn.svg';
import RoomPin from 'Components/RoomPin';
import { QuestionHelper } from 'Components/shared/QuestionHelper';
import { CopyComponent } from 'Components/VideoComponent/CopyComponent';
import { VideoTrialStatusMessage } from 'Components/VideoTrialStatusMessage';
import { VIDEO_URL } from 'Constants/env';
import {
  STORE_CONVERSATION,
  STORE_PERSON,
  STORE_SEARCH,
  STORE_UI,
} from 'Constants/stores';
import { debounce, isEmpty, uniqBy } from 'lodash';
import { MobXProviderContext, inject, observer } from 'mobx-react';
import { INewConference } from 'Models/ConversationModel';
import { SearchResult } from 'Models/SearchResult';
import moment, { Moment } from 'moment';
import * as React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import {
  Button,
  Dropdown,
  DropdownProps,
  Form,
  Grid,
  Icon,
  InputProps,
  Modal,
  Radio,
} from 'semantic-ui-react';

import { RootStoreProps } from 'Stores/RootStore.types';
import type { SearchableContactModelV2 } from 'Stores/SearchStore.types';

let timeout: any;

export interface IGroupMembers {
  key: string;
  text: string;
  value: string;
}

interface NewRoomState {
  showSuccessMessage: boolean;
  type: 'AdHocMeetNow' | 'AdHocScheduled';
  link: string;
  copied: boolean;
  hasMoreData: boolean;
  creatorName: string;
  showMorePhoneNumbers: boolean;
  creatingMeeting: boolean;
  joinByPhone: {
    pin?: string;
    dialInInfos?: { number: string }[];
  };
  laodingContacts: boolean;
  startDate: Moment;
  endDate: Moment;
  startTime: Moment;
  endTime: Moment;
  searchInput: string;
  allUsersSelected: SearchResult<SearchableContactModelV2>[];
}

const initialState: INewConference & NewRoomState = {
  displayName: '',
  invitees: [],
  visibility: 'Public',
  provider: 'bhive',
  showSuccessMessage: false,
  shouldStart: false,
  type: 'AdHocScheduled',
  link: '',
  copied: false,
  hasMoreData: true,
  textToCopy: [],
  creatorName: '',
  creatingMeeting: false,
  showMorePhoneNumbers: false,
  joinByPhone: {
    pin: undefined,
    dialInInfos: [],
  },
  laodingContacts: false,
  startDate: moment(),
  endDate: moment(),
  startTime: moment(),
  endTime: moment().add(15, 'minute'),
  searchInput: '',
  allUsersSelected: [],
};

class NewRoom extends React.Component {
  static contextType = MobXProviderContext;
  declare context: RootStoreProps;
  declare state: INewConference & NewRoomState;
  directorySearchThrottled: () => void;
  constructor(props) {
    super(props);
    this.state = initialState;
    this.directorySearchThrottled = debounce(
      () => void this.context.search.getDirectorySearch('USERS'),
      100,
      { leading: false }
    );
  }

  UNSAFE_componentWillMount() {
    this.directorySearchThrottled();
  }

  handleChangeVisibility = (e, { value }) =>
    this.setState({ visibility: value });

  handleChangeShouldStart = (e, { value }) => this.setState({ type: value });

  handleNameInsertion = ({ currentTarget }) =>
    this.setState({ displayName: currentTarget.value });

  handleOnChangeDropdown = (e, d: DropdownProps) => {
    const { search } = this.context;
    const directory = search.directoryMap?.['USERS'];
    const filteredResults = directory?.data;
    const filteredResultsCheckbox = filteredResults?.filter(
      (person) =>
        !!person.label &&
        (d.value as string[]).includes(person?.source?.id?.toString())
    );
    const mergedPrevCurrent = uniqBy(
      [...this.state.allUsersSelected, ...filteredResultsCheckbox],
      (person) => person?.source?.id
    );
    this.setState(
      {
        invitees: d.value as string[],
        allUsersSelected: mergedPrevCurrent,
        searchInput: '',
      },
      () => this.handleFocus(mergedPrevCurrent)()
    );
  };

  appendDateTime = (date: Moment, time: Moment) => {
    return date.set({
      hour: time.get('hour'),
      minute: time.get('minute'),
      second: 0,
      millisecond: 0,
    });
  };

  handleSave = () => async () => {
    this.setState({ creatingMeeting: true });
    const { conversation, person } = this.context;

    const data: INewConference = {
      provider: this.state.provider,
      visibility: this.state.visibility,
      displayName: this.state.displayName,
      invitees: this.state.allUsersSelected.map((searchResult) => {
        return { personId: searchResult.source.sourceId };
      }),
      shouldStart: this.state.type === 'AdHocMeetNow',
      textToCopy: this.state.textToCopy,
      type: this.state.type,
    };

    const creator = await person.loadPersonByIdGetIfMissingGet(
      person.loggedInPersonId.toString()
    );
    const respConference = await conversation.postNewConference(data);
    this.setState({ creatingMeeting: false });
    if (respConference) {
      const name = creator.firstName;

      const text = [
        `${name} is inviting you to a B-hive Video meeting ${
          this.state.displayName || ''
        }`,
        'Join meeting on',
        VIDEO_URL + respConference.data.id,
      ];
      const dialNumber =
        respConference.data?.dialInInfos?.length > 0
          ? formatPhoneNumberIntl(respConference?.data?.dialInInfos[0]?.number)
          : '';
      const pin = respConference.data?.pin?.match(/.{1,3}/g).join(' ') || '';
      this.setState({
        showSuccessMessage: true,
        link: VIDEO_URL + respConference.data.id,
        textToCopy: [...text, `\nDial in: ${dialNumber}\nPIN: ${pin}`],
        creatorName: name,
        joinByPhone: {
          pin: respConference.data?.pin,
          dialInInfos: respConference.data?.dialInInfos,
        },
      });
      if (!data.shouldStart) {
        conversation.toogleLinkModal();
      } else {
        this.setState(initialState);
      }
    }
  };

  handleModalClose = () => {
    this.context.conversation.toogleLinkModal();
    this.setState(initialState);
  };

  handleCopy = () => {
    const { ui } = this.context;
    ui.copyToClipboard(this.state.textToCopy);
    this.setState({ copied: true });
  };

  handleLoadContacts = async () => {
    const {
      ui: { handleLoadMoreContacts },
    } = this.context;
    if (this.state.hasMoreData && !this.state.laodingContacts) {
      this.setState({ laodingContacts: true });
      const resp: boolean = await handleLoadMoreContacts(false, true);
      resp
        ? this.setState({ hasMoreData: false, laodingContacts: false })
        : this.setState({ laodingContacts: false });
    }
  };

  handleScrollDown = () => {
    timeout = setTimeout(() => {
      const element: any = document.querySelector(
        '#inviteGroup > div.visible.menu.transition'
      );
      element.onscroll = (e: any) => {
        const bottom =
          e.target.scrollHeight -
          e.target.scrollTop -
          e.target.clientHeight -
          10;
        if (bottom <= 20 && this.state.hasMoreData) {
          this.handleLoadContacts();
        }
      };
    }, 500);
    if (!this.state.hasMoreData) {
      clearTimeout(timeout);
    }
  };

  handleShowMorePhoneNumbers = () => {
    this.setState({
      ...this.state,
      showMorePhoneNumbers: !this.state.showMorePhoneNumbers,
    });
  };

  refreshData = () => {
    const { ui } = this.context;
    ui.setTopBarSearchValue('');
    this.setState({ hasMoreData: true });
  };

  filter = debounce((inputProps: InputProps) => {
    const { search, ui } = this.context;
    void search.getDirectorySearch('USERS', inputProps.searchQuery);
    ui.setTopBarContactPageNumber(1);
  }, 300);

  onSearch = (e, inputProps: InputProps) => {
    this.setState({ hasMoreData: true, searchInput: inputProps.searchQuery });
    this.filter(inputProps);
  };

  handleStartDatePick = (date: Date) =>
    this.setState({ startDate: moment(date), endDate: moment(date) });

  handleStartTimePick = (date: Date) => {
    const { endTime } = this.state;
    const selectedDate = moment(date);
    const diff = this.context.ui.dateDiff(selectedDate, endTime);
    this.setStartEndDate(diff, date, 'add');
  };

  handleEndTimePick = (date: Date) => {
    const { startTime } = this.state;
    const selectedDate = moment(date);
    const diff = this.context.ui.dateDiff(selectedDate, startTime);
    this.setStartEndDate(diff, date, 'substract');
  };

  setStartEndDate = (
    diff: number,
    date: Date,
    operationType: 'add' | 'substract'
  ) => {
    //prevent setting endDate earlier than startDate ( both ways )
    let startEnd = {};
    if (operationType === 'add') {
      startEnd =
        diff > 0
          ? {
              startTime: moment(date),
              endTime: moment(date).add(15, 'minute'),
            }
          : {
              startTime: moment(date),
            };
    } else if (operationType === 'substract') {
      startEnd =
        diff < 0
          ? {
              startTime: moment(date).subtract(15, 'minute'),
              endTime: moment(date),
            }
          : {
              endTime: moment(date),
            };
    }
    this.setState({ ...startEnd });
  };

  handleFocus = (options) => () => {
    const { searchInput } = this.state;
    if (!searchInput && options?.length < 20) {
      this.directorySearchThrottled();
    }
    document.querySelector<HTMLInputElement>('#inviteGroup input').focus();
  };

  LinkModal = () => {
    const {
      conversation: { showLinkModal },
      ui,
    } = this.context;
    const { creatorName, displayName, copied, link, joinByPhone } = this.state;
    const dialNumber =
      joinByPhone?.dialInInfos?.length > 0
        ? formatPhoneNumberIntl(joinByPhone?.dialInInfos[0]?.number)
        : '';

    return (
      <Modal
        open={showLinkModal}
        size="small"
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={this.handleModalClose}
        className="link-modal"
        dimmer="blurring"
      >
        <Modal.Header>
          <span>Here’s the link to your meeting</span>
          <img
            className="close-btn pointer"
            src={closeBtn}
            onClick={this.handleModalClose}
          />
        </Modal.Header>
        <Modal.Content className="msg-group-dump-content" scrolling>
          <div>
            Copy this link and send it to people you want to meet with. Make
            sure you save this link so you can use it later.
          </div>
          <div className="link-box">
            <div className="text">
              <span>
                <b>{creatorName}</b> is inviting you to a B-hive Video meeting{' '}
                <b>{displayName}</b>.
              </span>
              <span>Join meeting on </span>
              <span className="link">{link}</span>
              <div className="semantic-flex-column">
                <span className="semantic-flex-row">
                  <b>Dial-in:&nbsp;</b> {dialNumber}
                </span>
                <span className="semantic-flex-row">
                  <b>PIN:</b>
                  <RoomPin pin={joinByPhone?.pin} />
                </span>
                {joinByPhone?.dialInInfos?.length > 1 && (
                  <div className="semantic-flex-column margin-top-1rem">
                    <span
                      className="toggle-more-phones"
                      onClick={this.handleShowMorePhoneNumbers}
                    >
                      {this.state.showMorePhoneNumbers
                        ? 'Less phone numbers'
                        : 'More phone numbers'}
                    </span>
                    {this.state.showMorePhoneNumbers && (
                      <div className="semantic-flex-column">
                        {joinByPhone?.dialInInfos?.slice(1).map((el, index) => (
                          <div key={`number-${el.number}-${index}`}>
                            <span className="semantic-flex-row">
                              {el.number}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <CopyComponent
              ui={ui}
              hovered={false}
              copied={copied}
              handleCopy={this.handleCopy}
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  render() {
    //need showLinkModal for rerendering
    const { search, ui, person } = this.context;
    const {
      invitees,
      searchInput,
      laodingContacts,
      type,
      visibility,
      displayName,
      creatingMeeting,
    } = this.state;
    const directory = search.directoryMap?.['USERS'];
    const filteredResults = directory?.data;
    const filteredResultsCheckbox = filteredResults?.filter(
      (person) => !!person.label
    );
    const mergedResults =
      filteredResultsCheckbox &&
      uniqBy(
        [...this.state.allUsersSelected, ...filteredResultsCheckbox],
        (person) => person?.source?.id
      );

    return (
      <div className="create-new-room">
        <div className="title-room">Create a New Meeting</div>
        <Form>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <div className="meeting-settings">MEETING SETTINGS</div>
                <Radio
                  label="Instant Meeting"
                  name="shouldStart"
                  value="AdHocMeetNow"
                  checked={type === 'AdHocMeetNow'}
                  onChange={this.handleChangeShouldStart}
                  className="radio-btn"
                />
                <span className="light-text">
                  Starts the meeting immediately.
                </span>
                <Radio
                  label="Create a meeting for later"
                  name="shouldStart"
                  onChange={this.handleChangeShouldStart}
                  checked={type === 'AdHocScheduled'}
                  value="AdHocScheduled"
                  className="radio-btn"
                />
                <span className="light-text">
                  Generates a shareable meeting link for future use.
                </span>
              </Grid.Column>
              <Grid.Column>
                <div className="room-type">ROOM TYPE</div>
                <Radio
                  label="Public"
                  name="visibility"
                  value="Public"
                  checked={visibility === 'Public'}
                  onChange={this.handleChangeVisibility}
                  className="radio-btn"
                />
                <span className="light-text">
                  Any authenticated account member can join
                </span>
                <Radio
                  label="Private"
                  name="visibility"
                  value="Private"
                  checked={visibility === 'Private'}
                  onChange={this.handleChangeVisibility}
                  className="radio-btn"
                />
                <span className="light-text">
                  Non invited users need confirmation to join.
                </span>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Form.Field className="margin-top-2rem">
            <Form.Input
              data-private
              className="input-field"
              fluid
              label="MEETING TITLE"
              placeholder="My New Meeting"
              value={displayName}
              onChange={this.handleNameInsertion}
              id="displayName"
            />
          </Form.Field>
          <Form.Field className="invite-section">
            <div className="semantic-flex-row semantic-flex-justify-start semantic-flex-align-items-center">
              <span className="invite-label">INVITE USERS</span>
              <QuestionHelper
                testid="-inviteUsers"
                content="Invited users will be able to join the meeting without confirmation. You are still responsible to send them the meeting link."
              />
            </div>
            <Dropdown
              placeholder="ex. John Doe"
              icon={
                isEmpty(invitees) && (
                  <Icon name="search" color="grey" className="search-icon" />
                )
              }
              className="invite-group"
              id="inviteGroup"
              fluid
              multiple
              searchQuery={searchInput}
              search
              selection
              loading={laodingContacts}
              value={invitees}
              options={mergedResults as IGroupMembers[]}
              onChange={this.handleOnChangeDropdown}
              onOpen={this.handleScrollDown}
              onSearchChange={this.onSearch}
              onClose={this.refreshData}
              onClick={this.handleFocus(mergedResults)}
            />
          </Form.Field>
        </Form>
        <div className="semantic-flex-row semantic-flex-align-items-center new-room-btn">
          <Button
            id="start-meeting"
            content="NEW MEETING"
            disabled={creatingMeeting}
            className="semantic-flex-fluid"
            onClick={this.handleSave()}
          />
        </div>
        {person.personAvaliableFeatures.video.enabled &&
          person.personAvaliableFeatures.video.expirationDate && (
            <VideoTrialStatusMessage
              message={`Your free trial will expire in ${ui.getTimeLeft(person.personAvaliableFeatures.video.expirationDate)}!`}
            />
          )}
        {<this.LinkModal />}
      </div>
    );
  }
}

export default inject(
  STORE_SEARCH,
  STORE_CONVERSATION,
  STORE_UI,
  STORE_PERSON
)(observer(NewRoom));
